import React, { useState,useEffect } from 'react'
import { getCourseListAPI } from '../../API/AdminServices'
import UserList from '../../Components/UserList/UserList'
import { separate } from '../../Functions/SeprateThreeNumber'
import Style from './AccountingPage.module.css'
import Modal from '../../Components/Modal/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDotCircle, faList } from '@fortawesome/free-solid-svg-icons'
const AccountingPage = () => {
    const[courseList,SetCourseList]=useState([])
    const[courseDetail,setCourseDetail]=useState()
    const[courseInfo,setCourseInfo]=useState()
    useEffect(()=>{
        getCourseList()
    },[])
    const getCourseList=async()=>{
        const data=await getCourseListAPI()
        SetCourseList(data.courses)
        setCourseDetail(data)
    }
    const[purchased,setPurchased]=useState(false)

    const closeModalHandler=()=>{
        setPurchased(false)
    }
    const showModalHandler=async(item)=>{
        setCourseInfo(item)
        setPurchased(true)
    }
    return (
        <div className={Style.PageHolder}>
            <Modal show={purchased} modalClose={closeModalHandler} translate={30}>
                <div className={Style.chatReply}>
                    {courseInfo===undefined||courseInfo.length===0 ?'دوره ای خریداری نکرده':
                    courseInfo.map(item=>{
                        return(
                            <p className={Style.ListCourse} key={item.id}> <FontAwesomeIcon icon={faDotCircle}/> {item.name} </p>
                        )
                    })
                    }
                </div>
            </Modal>
            <div className={Style.ImageHolder}><img src="/Assets/Images/Price/accounting.svg" alt="barber" /></div>
            <div className={Style.countingPrice}>
                <h3><span>{courseDetail===undefined?'لطفا منتظرباشید':courseDetail.total_user}</span>تعداد دوره های فروخته شده:</h3>
                <p className={Style.countingPart}><span>{courseDetail===undefined?'لطفا منتظرباشید':courseDetail.total_paid}</span>هزینه دریافتی کل:</p>
                {
                    courseList.map(item=>{
                        return(
                                <h3 key={item.id} className={Style.countingPart}><span>{item.total_user===null?'0':item.total_user}</span>{`تعداد کاربران دوره ${item.name}`}</h3>
                        )
                    })
                }
                {
                    courseList.map(item=>{
                        return(
                                <p key={item.id} className={Style.countingPart}><span>{separate(item.total_paid===null?'0':item.total_paid)}</span>{` هزینه دریافتی از دوره ${item.name}`}</p>
                        )
                    })
                }
                
            </div>
            <UserList showModalHandler={showModalHandler}/>
        </div>
    )
}

export default AccountingPage
